import { render } from "./BaseLogin.vue?vue&type=template&id=6fa8ccd1"
import script from "./BaseLogin.vue?vue&type=script&lang=js"
export * from "./BaseLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__